import { Button, Drawer, Box} from "@mui/material"
import { useState } from "react"
import { useTranslate } from "react-admin"
import AuditTrail from "../AuditTrail"

const AuditTrailDrawer = () => {

  const [open, setOpen] = useState<boolean>(false)
  const translate = useTranslate()

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <Button 
        size='small' 
        onClick={handleOpen}
      >
        {translate('resources.auditTrail.name')}
      </Button>
      <Drawer
        anchor="right"
        open={open}
        onClose={handleClose}
      >
        <Box minWidth={640} p={4}>
          <AuditTrail />
        </Box>
      </Drawer>
    </>
  )
}

export default AuditTrailDrawer